import React from 'react';
import { Provider } from 'react-redux';
import SnackbarMessage from './SnackbarMessage';

export default function SnackbarMessageWrapper(props) {
    return (
        <Provider store={window.ConnectReduxStore}>
            <SnackbarMessage />
        </Provider>
    );
}
